import React, { memo } from 'react';
import getI18n from '../i18n';

const I18nContext = React.createContext(getI18n());
I18nContext.displayName = 'I18nContext';

export const I18nConsumer = I18nContext.Consumer;
export const I18nProvider = memo(({ value, children }) => (
  <I18nContext.Provider value={value || getI18n()}>{children}</I18nContext.Provider>
));

export default I18nContext;
